module.exports = __webpack_public_path__ + "static/media/nutrition.87f30923.png";